import React from 'react';
import { Button, Space } from 'antd';
import { Eye, Download } from 'lucide-react';
import { FormikProps } from 'formik';

interface Attachment {
    id: string;
    label: string;
    role: string;
    value: string | null;
}

interface WorkflowData {
    valueData: {
        attachments?: Attachment[];
        [key: string]: any;
    };
    [key: string]: any;
}

interface DocumentActionsProps {
    formikProps?: FormikProps<WorkflowData>;
    field?: {
        props?: {
            fromContext?: Record<string, any>;
        };
    };
    data?: WorkflowData;
}

const DocumentActions: React.FC<DocumentActionsProps> = ({ formikProps, field, data }) => {
    const values = formikProps?.values || data || {};
    // @ts-ignore
    const attachments = values.valueData?.attachments || [];

    const handlePreview = (documentId: string) => {
        window.open(`/api/files/preview/documents/${documentId}`, '_blank');
    };

    const handleDownload = (documentId: string) => {
        window.open(`/api/files/documents/${documentId}`, '_self');
    };

    return (
        <div className="space-y-4">
            {
                // @ts-ignore
                attachments.map((attachment) => (
                <div key={attachment.id} className="flex justify-between items-center p-2 border rounded">
                    <span>{attachment.label}</span>
                    <Space size="small">
                        <Button
                            type="text"
                            icon={<Eye className="w-4 h-4" />}
                            onClick={() => handlePreview(attachment.id)}
                        >
                            Preview
                        </Button>
                        <Button
                            type="text"
                            icon={<Download className="w-4 h-4" />}
                            onClick={() => handleDownload(attachment.id)}
                        >
                            Download
                        </Button>
                    </Space>
                </div>
            ))}
            {attachments.length === 0 && (
                <div className="text-center text-gray-500">
                    No documents available
                </div>
            )}
        </div>
    );
};

export default DocumentActions;